import { useLocation } from 'react-router-dom';
export function useBasepathUrl(levels=0) {
  let levelsInt = parseInt(levels);
  const { pathname } = useLocation();
  const basePathUrl = (levelsInt > 0) ? pathname.split('/').slice(0, -levelsInt).join('/') : pathname;
  return basePathUrl;
}
